import { FC } from 'react';
import { Shipments } from 'components/Shipments';
import { Page } from 'layouts/Page';

export const ShipmentsPage: FC = () => {
	return (
		<Page title="Swiss Post – EAS Control Center">
			<Shipments />
		</Page>
	);
};
